import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import parse from 'html-react-parser';
import './assets/scss/styles.scss';
import { pdfReader, translate } from '../../assets/js/functions';
import { FaFilePdf } from 'react-icons/fa';

export default function ExploreItem({item, onClick, open = false}) {


    function _handleClick(){
        onClick && onClick(item.term_id, open)
    }

    if (item)
    return <>
            <div className='card'>
                <span   onClick={() => _handleClick()}
                        aria-controls={"collapse_"+item.term_id}
                        aria-expanded={open} className="btn clickable" >
                            { item.term }
                </span>
                <Collapse in={open}>
                    <span id={"collapse_"+item.term_id}>
                        { parse(item.abstract) }
                        {
                            item.pdf_resolved &&
                            <button onClick={() => pdfReader(JSON.parse(item.pdf_resolved)[0])} className='btn btn-anexo venobox'>{ translate('Ver gráfico anexo') } <FaFilePdf/></button>
                        }
                    </span>
                </Collapse>
            </div>
        </>
    else return null
}
